export class PromoCodeError extends Error {
    constructor(message) {
        super(message)

        this.message = message
    }
}

export class CreateReservationError extends Error {
    constructor(message) {
        super(message)

        this.message = message
    }
}

/*
    100	Could not validate reservation
    101	Could not process payment
    102	Could not save transaction
    103	No rates available for specified date/time period
    104	No Rates Available
    105	eDataLocationId not found in Reservation Database
    106	No reservation(s) found
    107	Rate amount does not match calculated amount
    108	Credit card not authorized
    109	Could not save transaction- Duplicate Reservation
    110	Failed to redeem reservation
    111	Failed to check duplicate reservation
    112	Credit card processor off-line
    113	Cannot find eLocationId details
    114	Location Number not available
    115	Location Number length cannot be less than 6 digit
    116	Remote server exception
    117	No parking available for the specified lot and times
    118	Merchant codes not provided for this location
    119	Soap client fault occurred
    120	Failure sending mail
    121	Could not create reservation.
    122	File not found
    123	Failure creating file
    124	File transfer error occured
    125	Invalid Account Details
    126	Could not found label
    127	Coupon sending failed
    128	Failed to redeem coupon
    129	Failed to send confirmation
    130	Invalid reservation
    131	Invalid confirmation
    132	Invalid coupon
    133	Invalid user email
    134	Invalid dates entered
    135	User already exists
    136	No inventory available for specified date/time period
    137	Could not amend reservation
    138	Could not extend reservation
    139	Invalid parking pass
    140	Parking start time cannot be less or equals current time
    141	Parking end time cannot be less or equals current time
    142	Create order failed
    143	Cannot VOID reservation
    144	Cannot cancel this reservation
    145	Parking location details not found
    146	Reservation template not found
    147	General exception in EmbeddedHTML
    148	General exception in SaveStreamAsImage
    149	Failed to generate email footer pdf
    150	Parking Pass Template not found
    151	Failed to retrieve language details by ISOLanguageCode
    152	Reservation is not allowed now as per booking rule
    153	Minimum length of the stay is InValid
    154	Maximum length of the stay is exceeded the booking limit
    155	Amount must be greater than zero
    156	Incorrect card details entered
    157	Unable to process request please try later
    158	Reservation acknowledgement template not found
    159	Option amount not matching
    160	Promo code not matching
    161	Promo code already redeemed
    162	Promo code amount not matching
*/
